export {default as appLogoDe} from './app-logo-de.svg';
export {default as appLogoEn} from './app-logo-en.svg';